import { Grid, TableCell, TableRow } from "@mui/material";
import { detailRowColumnWidths, entryTableHeaderStyle, entryTableRowStyle, productPartColumnWidths } from "../../../style/salesRecordCollectiveEntryStyle";
import { grey } from "@mui/material/colors";


function EntryTableHeaderRow() {

  return (
    <TableRow sx={{...entryTableHeaderStyle}}>
      <TableCell sx={{...entryTableRowStyle.product, px: 1, backgroundColor: grey[100]}}>
        <Grid container columnSpacing={1}>
          <Grid item sx={{...productPartColumnWidths.salesRecordNo}}>
            販売原票No.
          </Grid>
          <Grid item sx={{...productPartColumnWidths.productName}}>
            商品名
          </Grid> 
          <Grid item sx={{...productPartColumnWidths.needsPrintForEachDetail}}>
            明細毎<br />印刷
          </Grid>  
        </Grid>
      </TableCell>
      <TableCell sx={{...entryTableRowStyle.detail, px: 1}}>
        <Grid container columnSpacing={2}>
          <Grid item sx={{...detailRowColumnWidths.plusButton}}/>
          <Grid item sx={{...detailRowColumnWidths.minusButton}}/>
          <Grid item sx={{...detailRowColumnWidths.origin}}>
            産地
          </Grid> 
          <Grid item sx={{...detailRowColumnWidths.rank}}>
            等級
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.productClass}}>
            階級
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.packing}}>
            荷姿
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.supplyWeight}}>
            注文<br/>重量
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.supplyUnitName}}>
            発注<br/>単位
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.supplyUnitQuantity}}>
            入数
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.supplyQuantity}}>
            発注<br/>数量
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.acceptanceLabelNo}}>
            送り状No
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.partition}}>
            仕切No
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.weight}}>
            重量
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.quantity}}>
            数量
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.purchacePrice}}>
            仕入値
          </Grid>
          <Grid item sx={{...detailRowColumnWidths.directorEmployeeId}}>
            担当者ID
          </Grid>
        </Grid>
      </TableCell>
      <TableCell item sx={{...entryTableRowStyle.showSalesRecordButton, px: 1}} />
    </TableRow>
  )
}

export default EntryTableHeaderRow;